import React from 'react';
import createReactClass from 'create-react-class';
import auth0 from '../helpers/auth0';

const UserIsNotAllowed = createReactClass({
  getInitialState() {
    return {
      name: null,
      email: null
    };
  },

  componentDidMount() {
    const auth0Data = auth0.getTokenDataFromCache();

    const {name, email} = auth0Data;

    this.setState({
      name,
      email,
    });
  },

  logout() {
    auth0.logout();
    window.location.hash = '';
    window.location.reload();
  },

  render() {
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'center', height: '500px'}}>
        <img src="/images/logo.png" alt="Lagerverwaltung" width="146" height="52"/>
        <h2>Tut uns sehr leid!</h2>
        <h3>Die Emailadresse <b>{this.state.email}</b> ist momentan nicht für Lagerpark freigeschaltet.</h3><h3> Bitte wenden Sie sich an Ihren Ansprechpartner bei der Firma Softwarepark.</h3>
        <button onClick={() => this.logout()}>Zurück</button>
      </div>
    );
  }

});

export default UserIsNotAllowed;



// WEBPACK FOOTER //
// ./src/components/UserIsNotAllowed.js